import { addStyles } from 'ethcss'
import { colors, grid, IStyles, item } from 'theme'
import { mediaCSS } from 'theme/media'

export const styles: IStyles = {
    details: {
        position: 'fixed',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 2000,
    },
    detailsInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: colors.white,
        borderRadius: 20,
        padding: 30,
        width: 920,

        [mediaCSS.tab]: {
            padding: '12px 4px',
            borderRadius: 10,
            width: '98%',
        },
    },
    caption: {
        fontSize: 22,
        marginBottom: 30,

        [mediaCSS.tab]: {
            fontSize: 18,
        },
    },
    downloadButton: {
        position: 'absolute',
        right: 4,
        top: 12,
    },
    closeButton: {
        margin: '0 auto',
        padding: '8px 30px',
    },
    compareContainers: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 30,
        height: 'calc(100vh - 260px)',
        lineHeight: 1.3,
    },
    compareContainerHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 10,
    },
    compareTitle: {
        fontSize: 16,

        [mediaCSS.tab]: {
            fontSize: 14,
        },
    },
    compareContainer: {
        width: '49%',
        height: '100%',
    },
    compareInner: {
        background: colors.modalBackground,
        height: 'calc(100% - 26px)',
        overflow: 'auto',
        color: colors.blackLight,

        pre: {
            width: '100%',
        },
    },
    codeBlock: {
        display: 'flex',
        margin: '0 0 1em',
    },
    lineNumber: {
        display: 'block',
        color: colors.blackLight,
        padding: '0 4px',
    },
    spanCode: {
        minWidth: '97%',
        display: 'inline-block',
    },
    gutter: {
        marginRight: 8,
        backgroundColor: colors.fadeGrey,
    },
    diff: {
        backgroundColor: colors.onlineSecondary,
    },
    eq: {
        backgroundColor: `${colors.warning} !important`,
    },
    arrowsBlock: {
        display: 'flex',
        height: 22,
    },
    arrow: {
        marginLeft: 10,
    },
    styleAccent: {
        backgroundColor: `${colors.blueAccent} !important`,
        color: colors.white,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 'calc(100vh - 260px)',
        marginBottom: 30,
    },
}

addStyles(styles)
